export default [
  {
    path: '/expertConsult/doctor/list', // 专家问诊 医生列表
    name: 'expertConsultDoctor',
    meta: {
      keepAlive: true,
      title: '医生列表'
    },
    component: () => import('@/views/doctor/list')
  },
  {
    path: '/expertConsult/doctor/detail', // 专家问诊 医生详情
    name: 'expertConsultDoctorDetail',
    meta: {
      title: '医生详情'
    },
    component: () => import('@/views/doctor/detail')
  },
  {
    path: '/expertConsult/doctor/orderRecord', // 下单记录
    name: 'expertConsultDoctorOrderRecord',
    meta: {
      title: '下单记录'
    },
    component: () => import('@/views/doctor/list/orderRecord')
  },
  {
    path: '/expertConsult/payment/:id?', // 专家问诊 订购支付
    name: 'expertConsultPayment',
    component: () => import('@/views/doctor/payment'),
    meta: {
      title: '订单中心'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/expertConsult.js